import type { AppDefinition } from '../../types/apps';

export const IntegrationsHubAppDefinition: AppDefinition = {
  appId: 'integrations-hub',
  name: 'Integrations',
  version: '1.0.0',
  description: 'Connect external services like Google Drive, Gmail, and more to sync your data.',

  entityTypes: [],
  requiresEntity: false,
  requiresProps: false,

  component: 'integrations-hub',

  icon: {
    type: 'phosphor',
    phosphorIcon: 'PlugsConnected',
    phosphorWeight: 'duotone',
    color: '#0ea5e9',
    metadata: {
      source: 'app',
      appId: 'integrations-hub',
      isAppIcon: true,
    },
  },

  defaultWindowSize: { width: 720, height: 680 },

  category: 'system',
  isSystem: true,
};

export default IntegrationsHubAppDefinition;
